module.exports = __webpack_public_path__ + "img/plan_lector.bca119a9.jpg";